import {lazy} from "../../lib/lazy.js";
export const staffManagementRoutes = [
  {
    path: "/staff-management",
    component: lazy(() => import(/* webpackChunkName: "staffManagementRoutes" */ "../../views/staff-management/index.js")),
    auth: "list-staff"
  }
];
